import { ProgressTicketPc } from './ProgressTicket/ProgressTicket.pc';
import { ProgressTicketMobile } from './ProgressTicket/ProgressTicket.mobile';
import { useIsMobile } from '../../../hook/useIsMobile';
import { useState } from 'react';
import { infoStore } from '../../../store/infoStore';

export type ProgressTicketCommonProps = {
  goOnlineTab: () => void;
  goMainEventTab: () => void;
  ticketCnt: number;
  isActiveTicket: boolean;
  showWarningModal: boolean;
  setShowWarningModal: (val: boolean) => void;
  hasTicketNum?: number;
};

export const ProgressTicket = ({
  goOnlineTab,
  goMainEventTab,
}: {
  goOnlineTab: () => void;
  goMainEventTab: () => void;
}) => {
  const isMobile = useIsMobile();
  const { info } = infoStore();
  const [showWarningModal, setShowWarningModal] = useState(false);
  const isActiveTicket = info.status === 1;
  const hasTicketNum = info?.userTicketInfo?.length;

  const commonProps: ProgressTicketCommonProps = {
    goOnlineTab,
    goMainEventTab,
    ticketCnt: info.ticketCnt,
    isActiveTicket,
    showWarningModal,
    setShowWarningModal,
    hasTicketNum,
  };

  return isMobile ? (
    <ProgressTicketMobile {...commonProps} />
  ) : (
    <ProgressTicketPc {...commonProps} />
  );
};
